// Pure helper for the "Not checked" chip: turns the backend's rule → reason
// map into a tooltip headline and popover lines. Kept JSX-free so node --test
// can import it.
const RULE_NAMES = {
  oil_pressure: 'oil pressure', oil_starvation: 'oil starvation', oil_temp: 'oil temperature',
  coolant_temp: 'coolant temperature', temp_trend: 'temperature plateau', knock: 'knock',
  lambda: 'mixture at WOT', charging: 'charging', fuel_pressure: 'fuel pressure',
  dead_channel: 'dead channels', wheel_speed: 'wheel speed scale',
};

// One line for the tooltip, a list for the popover. Every rule saying the same
// thing ("no engine channels logged") collapses to that; otherwise the reasons
// that aren't simply a missing channel come first, since those are the
// surprising ones (a voltage channel that never moves is a wiring fact).
export function uncheckedSummary(unchecked) {
  const entries = Object.entries(unchecked || {});
  if (entries.length === 0) return { headline: 'No engine channels to judge', lines: [] };
  const reasons = new Set(entries.map(([, why]) => why));
  if (reasons.size === 1) {
    const why = entries[0][1];
    return { headline: /no engine channels/i.test(why) ? 'No engine channels logged' : why, lines: [] };
  }
  const missing = entries.filter(([, why]) => /^no .* channel/i.test(why));
  const other = entries.filter(([, why]) => !/^no .* channel/i.test(why));
  const lines = [
    ...other.map(([rule, why]) => `${RULE_NAMES[rule] || rule}: ${why}`),
    ...(missing.length ? [`no channel for ${missing.map(([r]) => RULE_NAMES[r] || r).join(', ')}`] : []),
  ];
  return { headline: other.length ? lines[0] : 'No engine channels logged', lines };
}
